// src/components/ProductLoadingSkeleton.js
import React from 'react';

const ProductLoadingSkeleton = () => {
  return (
    <div className="container mx-auto p-4">
      {/* Header Skeleton */}
      <div className="animate-pulse mb-6">
        <div className="h-8 bg-gray-200 rounded-md w-3/4 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded-md w-1/2"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {/* Left Column - Product Images & Canvas */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Canvas Area */}
          <div className="flex justify-center mb-4">
            <div className="w-full max-w-[500px] h-[500px] bg-gray-100 rounded-lg"></div>
          </div>

          {/* Product Thumbnails */}
          <div className="mt-4 grid grid-cols-6 gap-2">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="h-16 bg-gray-200 rounded"></div>
            ))}
          </div>

          {/* Product Note */}
          <div className="mt-6 bg-gray-100 rounded-lg p-4">
            <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          </div>

          {/* Product Specifications */}
          <div className="mt-6 bg-gray-50 rounded-lg p-4">
            <div className="h-5 bg-gray-200 rounded w-1/2 mb-3"></div>
            <div className="grid grid-cols-2 gap-4">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        {/* Right Column - Customization */}
        <div className="bg-white p-6 rounded-lg shadow-md space-y-6">
          {/* Design Buttons */}
          <div>
            <div className="h-6 bg-gray-200 rounded w-1/3 mb-3"></div>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <div className="h-12 bg-gray-200 rounded w-full"></div>
              <div className="h-12 bg-gray-200 rounded w-full"></div>
            </div>
          </div>

          {/* Customization Area */}
          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded w-1/4 mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full mb-4"></div>
            <div className="h-32 bg-gray-200 rounded w-full"></div>
          </div>

          {/* Quantity and Instructions */}
          <div className="space-y-4">
            <div>
              <div className="h-5 bg-gray-200 rounded w-1/4 mb-2"></div>
              <div className="h-10 bg-gray-200 rounded w-full"></div>
            </div>
            <div>
              <div className="h-5 bg-gray-200 rounded w-1/3 mb-2"></div>
              <div className="h-24 bg-gray-200 rounded w-full"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Add to Cart Button */}
      <div className="mt-8">
        <div className="h-12 bg-gray-200 rounded w-full"></div>
      </div>
    </div>
  );
};

export default ProductLoadingSkeleton;